import React from 'react';
import EmptyStateIcon from '../svg/EmptyState';
import EmptyStateFlint from '../svg/EmptyStateFlint';
import EmptyStateIdea from '../svg/EmptyStateIdea';

const EmptyAgenda = ({ text, subtext, buttonText, theme }) => {

	const getIcon = () => {
		if (theme === 'flint') return <EmptyStateFlint />;
		if (theme === 'idea') return <EmptyStateIdea />;
		return <EmptyStateIcon />;
	}

	return (
		<div className="eagerly-empty-state  flow">
			<figure className="empty-state__figure" style={{ '--aspect-ratio': `1/1` }}>
				{ getIcon() }
			</figure>

			<div className="empty-state__body ">
				<div className="empty-state__copy">
					{text}
				</div>

				{ subtext &&
					<div>{subtext}</div>
				}

				{ buttonText &&
					<button>{buttonText}</button>
				}

			</div>
		</div>
	);
}

export default EmptyAgenda;
